import React from 'react';

function NextTopicButton({ onNextTopic, loading, error }) {
  return (
      <div className="next-topic-menu">
        <button
          className="next-button"
          onClick={onNextTopic}
          disabled={loading}
        >
          {loading ? 'Загрузка...' : 'Перейти к следующей теме'}
        </button>
        {error && <div className="error-message">{error}</div>}
      </div>
  );
}

export default NextTopicButton;
